// contexts/RatingContext.js
import React, { createContext, useState, useEffect } from 'react';
import { BASE_URL } from '../config/apiConfig';

export const RatingContext = createContext();

export const RatingProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const storedUserId = localStorage.getItem('user_id');
    const storedToken = localStorage.getItem('auth_token');
    if (storedUserId && storedToken) {
      setUserId(storedUserId);
      setToken(storedToken);
    }
  }, []);

  // Submit a new review
  const submitReview = async ({ product_id, stars, review }) => {
    if (!userId || !token) {
      throw new Error('User not authenticated');
    }

    const reviewData = {
      user_id: Number(userId),
      product_id,
      stars: stars.toString(),
      review,
    };

    const response = await fetch(`${BASE_URL}/rating`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(reviewData),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Failed to submit review');
    }

    return result;
  };

  // Fetch reviews for a product
  const getReviews = async (product_id) => {
    try {
      const response = await fetch(`${BASE_URL}/rating/${product_id}`);
      const result = await response.json();

      if (result.status !== 200) {
        throw new Error(result.message || 'Failed to fetch reviews');
      }

      return result.data; // array of reviews
    } catch (error) {
      console.error('Error fetching reviews:', error);
      return []; // return empty array on error
    }
  };

  return (
    <RatingContext.Provider value={{ userId, submitReview, getReviews }}>
      {children}
    </RatingContext.Provider>
  );
};
